import cl from 'clsx';
import Label from './Label';
import React from 'react';
const ErrorMessage = (props) => (React.createElement(Label, Object.assign({}, props, { className: cl('cds-error-message', props.className), as: 'div' })));
ErrorMessage.displayName = 'ErrorMessage';
export default ErrorMessage;
